import React from 'react';
import { OutboundLink } from 'gatsby-plugin-google-analytics';

function Randomizer(props) {
  const millsAds = [
    {
      image: '/romeo-juliet-2022/ads/phillips-gallery.jpg',
      link: 'https://www.phillips-gallery.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Phillips Gallery',
      class: 'webFormat',
    },
    {
      image: '/romeo-juliet-2022/ads/afcu.jpg',
      link: 'https://www.americafirst.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'America First Credit Union',
      class: 'webFormat',
    },
    {
      image: '/romeo-juliet-2022/ads/bmw.jpg',
      link: 'https://www.bmwutah.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'BMW of Utah',
      class: 'webFormat',
    },
    {
      image: '/romeo-juliet-2022/ads/challenger.jpg',
      link: 'https://www.challengerschool.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Challenger School',
      class: 'webFormat',
    },
    {
      image: '/romeo-juliet-2022/ads/hamilton-park.jpg',
      link: 'https://www.hamiltonparkinteriors.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Hamilton Park Interiors',
      class: 'webFormat',
    },
    {
      image: '/romeo-juliet-2022/ads/pbs.jpg',
      link: 'https://www.pbsutah.org/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'PBS Utah',
      class: 'webFormat',
    },
    {
      image: '/romeo-juliet-2022/ads/rc-willey.jpg',
      link: 'https://www.rcwilley.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'RC Willey',
      class: 'webFormat',
    },
    {
      image: '/romeo-juliet-2022/ads/regency.jpg',
      link: 'http://www.regencyroyale.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Regency Royal',
      class: 'webFormat',
    },
    {
      image: '/romeo-juliet-2022/ads/tuacahn.jpg',
      link: 'https://www.tuacahn.org/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Tuacahn Amphitheatre',
      class: 'webFormat',
    },
    {
      image: '/romeo-juliet-2022/ads/ufo.jpg',
      link: 'https://utahfestival.org/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Utah Festival Opera',
      class: 'webFormat',
    },
    {
      image: '/romeo-juliet-2022/ads/university-cu.jpg',
      link: 'https://www.ucreditu.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'University Federal Credit Union',
      class: 'webFormat',
    },
    {
      image: '/romeo-juliet-2022/ads/uofu-dance.jpg',
      link: 'https://tickets.utah.edu/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'University of Utah Dance',
      class: 'webFormat',
    },
    {
      image: '/romeo-juliet-2022/ads/werners.jpg',
      link: 'https://wernersmercedes.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Werners',
      class: 'webFormat',
    },
    {
      image: '/romeo-juliet-2022/ads/adibs.jpg',
      link: 'https://adibs.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Adib’s Rug Gallery',
      class: 'webFormat',
    },
    {
      image: '/romeo-juliet-2022/ads/pc-gallery.jpg',
      link: 'https://parkcitygalleryassociation.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Park City Gallery Association',
      class: 'webFormat',
    },
  ];

  const [randomAd] = React.useState(
    millsAds[Math.floor(Math.random() * millsAds.length)]
  );

  return (
    <>
      <br />
      <OutboundLink
        href={randomAd.link}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src={randomAd.image}
          alt={randomAd.alt}
          className={randomAd.class}
        />
      </OutboundLink>
      <br />
      <br />
      <hr />
      <br />
    </>
  );
}

export default Randomizer;
